/** @jsxImportSource @emotion/react */
import React, { useEffect } from "react";
import { FilterDropdownButton } from "./FilterDropdownButton";
import {
  Filter,
  FiltersInterface,
  TransactionType,
  TransactionTypeProps,
} from "../../config/consts";
import { useTradeHistoryFilterToggle } from "../../hooks/useTradeHistoryFilterToggle";
import { ReactComponent as TradeIcon } from "../../img/trade-history/swap.svg";
import { ReactComponent as SendIcon } from "../../img/trade-history/send.svg";
import { FilterOptionRow } from "./elements/FilterOptionRow";
import styled from "@emotion/styled";
import { Spacer } from "components/general/Spacer/Spacer";
import { Table } from "@tanstack/react-table";
import { TransactionDetail } from "types/history";

export interface TransactionFilterProps {
  table: Table<TransactionDetail>;
  confirmedOptions: FiltersInterface[Filter.Transaction];
  setConfirmedOptions: (updatedOptions: FiltersInterface[Filter.Transaction]) => void;
}

export const TransactionFilter: React.FC<TransactionFilterProps> = ({
  table,
  confirmedOptions,
  setConfirmedOptions,
}) => {
  const { localOptions, setLocalOptions, toggleLocalOptions } =
    useTradeHistoryFilterToggle<TransactionType>();

  useEffect(() => {
    setLocalOptions(confirmedOptions);
  }, [confirmedOptions, setLocalOptions]);

  return (
    <FilterDropdownButton
      filterType={Filter.Transaction}
      localOptions={localOptions}
      setLocalOptions={setLocalOptions}
      confirmedOptions={confirmedOptions}
      setConfirmedOptions={setConfirmedOptions}
      table={table}
    >
      <DropdownContainer>
        {Object.entries(TRANSACTION_CONFIG).map(([type, props], index) => {
          return (
            <FilterOptionRow
              key={type}
              onClick={() => toggleLocalOptions(type as TransactionType)}
              checked={localOptions?.includes(type as TransactionType) ?? false}
            >
              <Content>
                {props.icon}
                <Spacer width="8px" />
                {type}
              </Content>
            </FilterOptionRow>
          );
        })}
      </DropdownContainer>
    </FilterDropdownButton>
  );
};

// Sub-components

const DropdownContainer = styled.div`
  min-width: 234px;
`;

const Content = styled.div`
  background: transparent;
  border: 0;
  display: flex;
  align-items: center;
`;

// Helpers

export const TRANSACTION_CONFIG: Partial<Record<TransactionType, TransactionTypeProps>> = {
  [TransactionType.Trade]: {
    icon: <TradeIcon />,
  },
  [TransactionType.TradeAndSend]: {
    icon: <SendIcon />,
  },
};
